import { render, staticRenderFns } from "./instance.vue?vue&type=template&id=1f16f41e&"
import script from "./instance.vue?vue&type=script&lang=js&"
export * from "./instance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports